import { defineComponent as _defineComponent } from 'vue'
import 
TUIChatEngine,
{
  TUIStore,
  TUIGlobal,
  StoreName,
  TUITranslateService,
  TUIFriendService
} from "@tencentcloud/chat-uikit-engine";
import { computed, reactive, defineEmits, ref } from "../../../adapter-vue";
import documentLink from "../../../utils/documentLink";
import Icon from "../../common/Icon.vue"
import backIcon from "../../../assets/icon/back.svg";
import closeIcon from "../../../assets/icon/close.png";
import rightIcon from "../../../assets/icon/right.png";
import selectedIcon from "../../../assets/icon/selected.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['submit', 'cancel'],
  setup(__props, { emit }) {

const isPC = ref(TUIGlobal.getPlatform() === "pc");

const groupInfo = reactive({
  profile: {
    groupID: '',
    name: '',
    type: '',
    avatar: '',
    introduction: '',
    notification: '',
    joinOption: '',
  },
  groupConfig: {
    title: '',
    value: '',
    key: '',
    type: '',
    placeholder: '',
  },
  isEdit: false,
});

const type = [
  {
    icon: 'https://web.sdk.qcloud.com/im/assets/images/Public.svg',
    label: '陌生人社交群（Public）',
    type: TUIChatEngine.TYPES.GRP_PUBLIC,
    detail: '类似 QQ 群，创建后群主可以指定群管理员，用户搜索群 ID 发起加群申请后，需要群主或管理员审批通过才能入群。详见',
    src: '产品文档',
  },
  {
    icon: 'https://web.sdk.qcloud.com/im/assets/images/Meeting.svg',
    label: '临时会议群（Meeting）',
    type: TUIChatEngine.TYPES.GRP_MEETING,
    detail: '创建后可以随意进出，且支持查看入群前消息；适合用于音视频会议场景、在线教育场景等与实时音视频产品结合的场景。详见',
    src: '产品文档',
  },
  {
    icon: 'https://web.sdk.qcloud.com/im/assets/images/Work.svg',
    label: '好友工作群（Work）',
    type: TUIChatEngine.TYPES.GRP_WORK,
    detail: '类似普通微信群，创建后仅支持已在群内的好友邀请加群，且无需被邀请方同意或群主神奇。详见',
    src: '产品文档',
  },
  {
    icon: 'https://web.sdk.qcloud.com/im/assets/images/AVChatroom.svg',
    label: '直播群（AVChatroom）',
    type: TUIChatEngine.TYPES.GRP_AVCHATROOM,
    detail: '创建后可以随意进出，没有群成员数量上限，但不支持历史消息存储；适合与直播产品结合，用于弹幕聊天场景。详见',
    src: '产品文档',
  },
];



groupInfo.profile.type = type[0].type;
groupInfo.profile.avatar = type[0].icon;

const groupTypeDetail = computed(() => {
  return type.filter((item: any) => {
    return item.type === groupInfo.profile.type;
  })[0];
});

const selected = (item: any) => {
  if (groupInfo.profile.type !== item.type) {
    groupInfo.profile.type = item.type;
    groupInfo.profile.avatar = item.icon;
  }
};

const submit = (profile: any) => {
  if (groupInfo.isEdit) {
    (groupInfo.profile as any)[groupInfo.groupConfig.key] = groupInfo.groupConfig.value;
    return groupInfo.isEdit = !groupInfo.isEdit;
  }
  const options: object = {
    name: profile.name,
    type: profile.type,
    groupID: profile.groupID,
    avatar: profile.avatar,
  };
  emit('submit', options);
};

const cancelDialog = () => {
  if (groupInfo.isEdit) {
    return groupInfo.isEdit = !groupInfo.isEdit;
  }
  emit('cancel');
};

const edit = (label: string) => {
  groupInfo.isEdit = !groupInfo.isEdit;
  groupInfo.groupConfig.key = label;
  groupInfo.groupConfig.value = (groupInfo.profile as any)[label];
  switch (label) {
    case 'name':
      groupInfo.groupConfig.title = '设置群名称';
      groupInfo.groupConfig.placeholder = '请输入群名称';
      groupInfo.groupConfig.type = 'input';
      break;
    case 'groupID':
      groupInfo.groupConfig.title = '设置群ID';
      groupInfo.groupConfig.placeholder = '请输入群ID';
      groupInfo.groupConfig.type = 'input';
      break;
    case 'type':
      groupInfo.groupConfig.title = '选择群类型';
      groupInfo.groupConfig.type = 'select';
      break;
  }
};

const selectedEdit = (item: any) => {
  if (groupInfo.groupConfig.value !== item.type) {
    groupInfo.groupConfig.value = item.type;
  }
};

return { __sfc: true,isPC, groupInfo, type, emit, groupTypeDetail, selected, submit, cancelDialog, edit, selectedEdit, TUITranslateService, documentLink, Icon, backIcon, closeIcon, rightIcon, selectedIcon }
}

})